(angular => {

  angular.module("Auth", [])
    .config(["$routeProvider", configRouter]);

  function configRouter($routeProvider) {

    $routeProvider
      .when("/", {
        controller: "Auth.LoginCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/auth/login/login.html`,
        allowAnonymous: true
      })
      .when("/convidado/", {
        controller: "Auth.LoginGuestCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/auth/guest/guest.html`,
        allowAnonymous: true
      })
      .when("/convite/", {
        controller: "Auth.PublicGuestCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/auth/invitation/invitation.html`,
        allowAnonymous: true
      })
      .when("/convite/convidados/", {
        controller: "Auth.PublicGuestListCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/auth/invitation/invitation-list.html`,
        allowAnonymous: true
      })
      .when("/convite/login/", {
        controller: "Auth.PublicGuestLoginCtrl",
        controllerAs: "$ctrl",
        templateUrl: `public/pages/auth/invitation/invitation-login.html`,
        allowAnonymous: true
      });
  }

})(angular);
